import "./tatic_lib/logger.js";
import "./tatic_lib/errors.js";
import "./tatic_lib/easing.js";
import "./tatic_lib/$$.js";
import "./tatic_lib/collect.js";
import "./tatic_lib/storage.js";
import "./tatic_lib/hash.js";
import "./tatic_lib/utils.js";
import "./tatic_lib/test.js";
import "./tatic_lib/net.js";
import "./tatic_lib/cookies.js";
import "./tatic_lib/scroll.js";
import "./tatic_lib/sorter.js";
import "./tatic_lib/observe.js";
import "./tatic_lib/datetime.js";
import "./tatic_lib/color.js";
import "./tatic_lib/slider.js";
import "./tatic_lib/canvasslider.js";
import "./tatic_lib/motion.js";
import "./tatic_lib/userinteraction.js";
import "./tatic_lib/moddal.js";
import "./tatic_lib/toster.js";
import "./tatic_lib/selection.js";
import "./tatic_lib/datetime_dropdown.js";
import "./tatic_lib/color_dropdown.js";
import "./tatic_lib/tooltip.js";

document.addEventListener("DOMContentLoaded", function () {
    UserInteraction.init();
    window.toster = new Toster();
    window.tooltips = new Tooltip({ timeout: 2500 });
})

